import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var EVENT_SESSIONS_QUERY_KEY = 'eventSessions';
var eventSessionsKeys = {
  eventSessions: [EVENT_SESSIONS_QUERY_KEY],
  eventSessionDetail: function eventSessionDetail(eventId, sessionId) {
    return [EVENT_SESSIONS_QUERY_KEY, 'eventSessionDetail', String(eventId), String(sessionId)];
  },
  eventSessionsList: function eventSessionsList(eventId, startDate, page, limit) {
    return [EVENT_SESSIONS_QUERY_KEY, 'eventSessionsList', String(eventId), startDate, page, limit].filter(Boolean);
  },
  eventSessionAttendees: function eventSessionAttendees(_ref) {
    var eventId = _ref.eventId,
      sessionId = _ref.sessionId,
      page = _ref.page,
      status = _ref.status,
      search = _ref.search,
      limit = _ref.limit;
    return [EVENT_SESSIONS_QUERY_KEY, 'eventSessionAttendees', String(eventId), String(sessionId), page, status, search, limit].filter(function (value) {
      return value !== undefined;
    });
  }
};
export default eventSessionsKeys;